import * as React from 'react';
import { InputCaption, InputCaptionError } from '@atomic/atm.typography';
export var FormFieldCaption = function (props) {
    var _a;
    var wrap = props.errors.map(function (error, index) { return (React.createElement(InputCaptionError, { key: error.name + index }, error.message)); });
    return props.showAll ? (React.createElement("div", null, wrap)) : (React.createElement(React.Fragment, null, ((_a = props.errors) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (React.createElement(InputCaptionError, { key: props.errors[0].name }, props.errors[0].message)) : (props.validationPlaceholder && React.createElement(InputCaption, null, props.validationPlaceholder))));
};
